import { ControlButton, Controls } from '@xyflow/react';

interface QueryVisualizerToolbarProps {
  onFitView: () => void;
}

/**
 * QueryVisualizerToolbar - ReactFlow controls toolbar
 *
 * Provides:
 * - Fit View button to center and zoom graph
 *
 * Note: Other default ReactFlow controls (zoom in/out, interactive toggle)
 * are hidden via showFitView={false} and showInteractive={false}.
 */
export const QueryVisualizerToolbar = ({
  onFitView,
}: QueryVisualizerToolbarProps) => {
  return (
    <Controls
      showFitView={false}
      showInteractive={false}
      className="border-chariot-stroke bg-chariot-background-primary/90 [&_button]:border-b-chariot-stroke [&_button]:text-chariot-text-primary hover:[&_button]:bg-chariot-background-secondary/60 rounded-lg border-2 backdrop-blur-sm [&_button]:border-b-2 [&_button]:bg-transparent [&_button]:transition-all [&_button]:duration-200 last:[&_button]:border-b-0"
    >
      <ControlButton onClick={onFitView} title="Fit View">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" />
        </svg>
      </ControlButton>
    </Controls>
  );
};
